import { post } from '../fetch-extension';

export enum BioDataStatus {
    Approved = 'APPROVED',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Deleted = 'DELETED',
    Blocked = 'Blocked'
}

export type VerifyAgeResponse = {
    status: BioDataStatus;
};

export async function verifyAge(accountId: number, image: string) {
    const { error, result } = await post<VerifyAgeResponse>(`/biodata/clients/${accountId}/age`, {
        body: { image }
    });

    if (error) {
        return { error };
    }

    return { result: result! };
}
